import React, { FC } from 'react';
import { Spinner, styled } from '@grupoboticario/flora-react';
import { IPage } from 'src/common/types/CatalogType';
import { useStyle } from 'src/contexts/StyleContext';

interface IMobileSlide {
  page: IPage;
  hasSpinner?: boolean;
}

const StyledSlide = styled('div', {
  width: '100vw',
  height: 'auto',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',

  variants: {
    contrast: {
      true: {
        filter: 'grayscale(100%)',
      },
    },
  },

  img: {
    maxWidth: '100vw',
    position: 'relative',
    zIndex: 5,
    maxHeight: 'calc((96vh - 48px) - 62px)',
  },
});

const SpinnerWrapper = styled('div', {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const MobileSlide: FC<IMobileSlide> = ({ page, hasSpinner = false }) => {
  const { style } = useStyle();

  return (
    <StyledSlide key={page.number} contrast={style.contrast}>
      {hasSpinner && (
        <SpinnerWrapper aria-hidden="true">
          <Spinner data-testid="slide-loader" size="sm" color="$brand-1" />
        </SpinnerWrapper>
      )}
      <img
        src={page.image.replace(/\.jpg$/i, '.webp')}
        alt={page.description}
      />
    </StyledSlide>
  );
};
